var ABTestStorage = {
    get: function (key) {
        try {
            return localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    },
    set: function (key, value) {
        try {
            localStorage.setItem(key, value);
        } catch (e) { }
    },
    remove: function (key) {
        try {
            localStorage.removeItem(key);
        } catch (e) { }
    }
};
